<template>
  <div id="app">
    <floatTip></floatTip>
    <router-view></router-view>
  </div>
</template>

<script>
import floatTip from '@/components/floatTip/index.vue'
import { getAliOssAddress, getVipUser } from "./api/moudles/user.js";
export default {
  name: "App",
  components:{
    floatTip
  },
  created() {
    // this.getAliOss()
    this.checkIstimeOut();
  },
  methods: {
    async getAliOss() {
      await getAliOssAddress({
        success: (res) => {
          localStorage.setItem("ossPath", res.data);
        },
      });
    },
    checkIstimeOut() {
      getVipUser({
        success: (res) => {
          if (res.code === 403) {
            this.$store.commit("user/RESET_INFO");
          }
        },
      });
    },
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  background-color: #f5f5f5;
}

@media screen and (max-width: 750px) {
  .el-message-box {
    width: inherit !important;
  }
}

.el-message-box__header {
  text-align: center;
}

.el-message-box__message {
  text-align: center;
}

.el-message-box__btns {
  text-align: center !important;
}

.newConfirm {
  width: 120px;
  height: 40px;
  background-color: #c22c25 !important;
  border: none !important;
}

.v-modal {
  z-index: 989 !important;
}
</style>
